// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "5c0b610c618c5a6fb61b" + ".js";
};